module.exports = __webpack_public_path__ + "static/img/103892.890cc273.png";